/**
 * Clerk sign-up headings. The start subtitle replaces Clerk's
 * "Welcome! Please fill out the details to get started."
 */
export const clerkSignupCopy = {
	signUp: {
		start: {
			title: "Create Your Custom Account",
			subtitle: "Step 1 of 2",
		},
		emailLink: {
			subtitle: "Step 2 of 2",
		},
		emailCode: {
			subtitle: "Step 2 of 2",
		},
		phoneCode: {
			subtitle: "Step 2 of 2",
		},
		continue: {
			subtitle: "Step 2 of 2",
		},
	},
} as const;
